import * as React from "react";
import {PORTAL_CONTAINERS} from "../../../shared/PortalConstants";

type PortalDestinationProps = {
	children: React.ReactNode;
	name: typeof PORTAL_CONTAINERS[keyof typeof PORTAL_CONTAINERS];
} & Omit<React.ComponentProps<"div">, "id">;

export const PortalDestination = ({
	children,
	name,
	...props
}: PortalDestinationProps) => {
	return (
		<div id={name} {...props}>
			{children}
		</div>
	);
};
